// extracted by mini-css-extract-plugin
export var footer_heading = "footerTop-module--footer_heading--f0f2c";
export var footer_list = "footerTop-module--footer_list--5471c";
export var footer_social = "footerTop-module--footer_social--8c178";
export var footer_top_section = "footerTop-module--footer_top_section--cb2d5";
export var left_footer = "footerTop-module--left_footer--d9f1e";
export var right_footer = "footerTop-module--right_footer--43601";
export var right_footer_box = "footerTop-module--right_footer_box--6fe81";